import { hashPhoneNumber as hashPhoneNumberImpl } from '../utils/phoneHashUtils';

// Re-exported so this module stays the one import site for tracking hashes in
// this app. The implementation is shared with the caller-facing assist app,
// which reports the same tokens and has to hash them identically.
export { hashTrackingToken } from '@rsos/gainsight';

/**
 * Hashes an identifier for Gainsight entities when it looks like a phone number.
 * Returns undefined for null or undefined inputs.
 * hashPhoneNumberImpl is a JS function that requires a non-null string.
 */
export function hashTrackingId(
  id: string | null | undefined,
): string | undefined {
  if (id == null) {
    return undefined;
  }

  return hashPhoneNumberImpl(id);
}
